// removed by extract-text-webpack-plugin
module.exports = {"QuickResponseModal":"_2LA5h1Ek7s02I98XIzdwS8","Header":"_1RMXMDCZzVzPtYE2ZUxqUp","Search":"_3t2b0TcK4qQ3RUhM41BLON","ItemsWrapperOuter":"_34Q1ewooK3FlgW3uypCQaA","ItemsWrapperInner":"_1YvVDtgniaFYZ4LE1LpNlY","Item":"_1OdAipCIhN2RhwnbDS8CJ3","ItemText":"_2pHkIVTAAMK1RXQMwkxuXS","SearchInput":"_393Q-W17pxMLstIAXy8peL","NoItemIcon":"_3w_LVlWG3o0KlePDZGNsNu","NoItemText":"_2eU36ggAtz8p8vNgsCITm_","NoItemButton":"_1hZByneOvp6DZ6Q7ktBhaP"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/Conversation/QuickResponseModal/style.css
// module id = 815
// module chunks = 0